import React from 'react';
import { getSettingsSectionMeta } from './SettingsSidebar';

export default function SettingsSectionHeader({ sectionId, description }) {
  const meta = getSettingsSectionMeta(sectionId);
  const Icon = meta.icon;
  return (
    <div className="mb-6">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blue-600 text-white shadow-md">
          <Icon className="h-5 w-5" />
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{meta.group}</p>
          <h2 className="text-xl font-bold text-foreground">{meta.label}</h2>
          {description ? <p className="text-sm text-muted-foreground mt-1 max-w-2xl">{description}</p> : null}
        </div>
      </div>
    </div>
  );
}
